import { createElement } from "@max/max";
import { getFullScreenSize } from "@/utils/layout";
import ModalBaseContainer from '@max/leez-modal-base-container';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import LImage from '@max/leez-image';
import TopView from '@max/leez-top-view';
import ModalBottomBtn from "../modal-bottom-button";
import './index.scss';
export default function JoinedPopup(props) {
    const { fullScreenHeight } = getFullScreenSize();
    if (!props.visible) {
        return null;
    }
    return <TopView>
      <ModalBaseContainer visible={props.visible} contentStyle={{
        width: '750rpx',
        height: fullScreenHeight,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative'
    }}>
        
        <LImage source={{
        uri: 'https://p0.meituan.net/ingee/ab1d77571e957ab85d2cbb37f1fed4c428223.png'
    }} style={{
        width: '342rpx',
        height: '5126rpx'
    }}></LImage>
        <LImage source={{
        uri: 'https://p0.meituan.net/ingee/29fe0d15369e35bb19509cc3e77dc3858083.png'
    }} style={{
        width: '564rpx',
        height: '512rpx',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    }}>
          
          <View className="joined-popup-card">
            <Text className="joined-popup-subtitle">找到组织</Text>
            <Text className="joined-popup-description">快去邀人打Call，冲榜赢免单！</Text>

            <View style={{
        marginTop: '85rpx'
    }}>
              
              <ModalBottomBtn buttonText={'邀好友来打Call'} onPress={props.onInviteCall}/>
            </View>
          </View>
        </LImage>

        
        <LImage onPress={props.onClose} source={{
        uri: 'https://p0.meituan.net/ingee/94047ffc6fa8ede65644e7a2653da1691779.png'
    }} style={{
        width: '48rpx',
        height: '48rpx',
        marginTop: '60rpx'
    }} className="joined-popup-close-btn"/>
      </ModalBaseContainer>
    </TopView>;
}
